import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-common-task-status-archive',
  templateUrl: './common-task-status-archive.component.html',
  styleUrls: ['../parts.css']
})
export class CommonTaskStatusArchiveComponent implements OnInit {
  boardData: any = {}; // 面板数据
  boardColumnData: Array<any> = []; // 面板表头数据
  columnId: string;
  columnConditionVisible = false;
  columnConditionData;
  columnConditionDisplayText = '状态';
  columnConditionSelectList = [];

  statusConditionVisible = false;
  statusConditionData;
  statusConditionDisplayText = '某个值';
  statusConditionSelectList = [];

  recipeId;
  relationId;
  categorieId;

  instanceData: any = {}; // 存放实例返填数据

  automation: any = {
    boardId: '',
    groupId: '',
    categoryId: '',
    relationId: '',
    conditions: [{}],
    columnId: '',
    columnValue: {
      index: ''
    },
    instanceDescription: ''
  };

  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor() { }

  ngOnInit() {
    if (this.boardData && JSON.stringify(this.boardData) !== '{}') {
      this.boardColumnData = this.boardData.boardData.columns;
      for (const column of this.boardColumnData) {
        if (column.type === 'taskProgress') {
          this.columnId = column.id;
          this.columnConditionSelectList.push(column);
        }
      }
      this.boardData.boardData.pulses.forEach(item => {
        if (item.columnValues[this.columnId] && item.columnValues[this.columnId].labels && item.columnValues[this.columnId].labels.length) {
          this.statusConditionSelectList = item.columnValues[this.columnId].labels;
        }
      });
    }
    if (this.instanceData && JSON.stringify(this.instanceData) !== '{}') {
      if (this.instanceData.config) {
        this.columnConditionData = this.instanceData.config.columnId;
        this.automation.columnId = this.columnConditionData;
        this.automation.columnValue = this.instanceData.config.columnValue;
        this.statusConditionData = this.automation.columnValue.index;
        this.initSelectData();
        this.packageData();
      }
    }
    this.automation.relationId = this.relationId;
    this.automation.categoryId = this.categorieId;
  }

  initSelectData() {
    for (const column of this.columnConditionSelectList) {
      if (this.columnConditionData === column.id) {
        this.statusConditionSelectList = column.labels;
        this.columnConditionDisplayText = column.title;
        break;
      }
    }
    for (const status of this.statusConditionSelectList) {
      if (this.statusConditionData === status.index) {
        this.statusConditionDisplayText = status.label ? status.label : '默认';
      }
    }
  }

  columnConditionChange(item) {
    this.columnConditionData = item.id;
    this.columnConditionDisplayText = item.title;
    this.statusConditionSelectList = item.labels;
    this.columnConditionVisible = false;
    this.automation.columnId = this.columnConditionData;
    this.statusConditionData = null;
    this.automation.columnValue.index = '';
    this.packageData();
  }

  statusConditionChange(item) {
    this.statusConditionData = item.index;
    this.statusConditionDisplayText = item.label ? item.label : '默认';
    this.statusConditionVisible = false;
    this.automation.columnValue.index = this.statusConditionData;
    this.packageData();
  }

  packageData() {
    this.automation.instanceDescription = '当 ' + this.columnConditionDisplayText + ' 变更为 ' + this.statusConditionDisplayText + ' 时， 归档这个任务';
    this.nfDataChange.emit(this.automation);
  }

  // 获取当前提交状态，当所有必填项都填写时返回true
  getSubmitStatus(): boolean {
    return this.columnConditionData && this.statusConditionData != null;
  }
}
